import BuddiesInput from './BuddiesInput';

export default BuddiesInput;
